import React from "react";
import { GetCorServicei, genURL } from "./../_getjson";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Tab, Tabs } from "react-bootstrap"
import PopUpSaleOder from "./PopUpSaleOder";
import { AlertPopup } from "./../PopUp/AlertPopup"
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
require("./../_css/PopUpOther.css");
export default class PopUpSelect extends React.Component {
  constructor(props) {
    super(props);
    this.P_DOCNO = React.createRef();
    this.UserCode = React.createRef();
    this.UserCode_code = React.createRef();
    this.SalecodeMTequal = React.createRef();
    this.SalecodeMTequal_code = React.createRef();
    this.SalecodeLTequal = React.createRef();
    this.SalecodeLTequal_code = React.createRef();
    this.SalecodeMthan = React.createRef();
    this.SalecodeMthan_code = React.createRef();
    this.SalecodeLthan = React.createRef();
    this.SalecodeLthan_code = React.createRef();
    this.state = {
      rows: [],
      products: [],
      products1: [],
      casschkbox: "far fa-square",
      casschkboxs: false,
      key: "SelectTab1",
      openBackdrop: false,
    }
  }
  // กำหนดตาราง เลือกเป็นช่วง
  setRow = () => {
    var data = [];
    for (var i = 0; i <= 20 - 1; i++) {
      data[i] = {
        N: i + 1,
        BTN_StCode: 0
      };
    }
    this.setState({ products1: data });
  };
  // รับค่า
  Get_PopUpSelSaleRef3Sub = (data) => {
    let id = this.state.id
    var input = this.state.data
    if (input === '1') {
      this.UserCode.current.value = data[0].ArCode
      this.UserCode_code.current.value = data[0].Description
    }
    if (input === '2') {
      this.SalecodeMTequal.current.value = data[0].ArCode
      this.SalecodeMTequal_code.current.value = data[0].Description
    }
    if (input === '3') {
      this.SalecodeLTequal.current.value = data[0].ArCode
      this.SalecodeLTequal_code.current.value = data[0].Description
    }
    if (input === '4') {
      this.SalecodeMthan.current.value = data[0].ArCode
      this.SalecodeMthan_code.current.value = data[0].Description
    }
    if (input === '5') {
      this.SalecodeLthan.current.value = data[0].ArCode
      this.SalecodeLthan_code.current.value = data[0].Description
    }
    if (input === 'table') {
      var col = this.state.products1
      col[id].StCode = data[0].Description
      col[id].StName = data[0].ArCode
      this.setState({ products1: col })
    }
    if (input === 'table1') {
      var col = this.state.products1
      col[id].SpCode = data[0].Description
      col[id].SpName = data[0].ArCode
      this.setState({ products1: col })
    }
    this.setState({ SaleOderSub: !this.state.SaleOderSub });
  };

  componentDidMount() {
    this.setState({ openBackdrop: true })
    var dataArray = [];
    if (this.props.type === "SaleMan") {
      var url = "CSUSER/All?";
    }
    if (this.props.type === "Groupdata") {
      var url = "CSDOCGROUP/Searchbytbname?tablename=cssaleorder";
    }
    console.log(genURL(url));
    axios.get(genURL(url)).then(res => {
      var j = 0;
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          dataArray[j] = {
            id: i + 1,
            ArCode: res.data[i].Code,
            Description: res.data[i].MyNameTH,
            SB: "0",
          }
          j++;
        }
        this.setState({ products: dataArray });
        this.setState({ openBackdrop: false })
      } else {
        dataArray = [];
        this.setState({ products: dataArray });
        this.setState({ openBackdrop: false })
      }
    }).catch(error => {
      this._chkload("Error" + error);
      this.setState({ openBackdrop: false })
    });


    this.setRow()
  }
  // เลือกรายการ
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")} style={{ paddingTop: "7px", fontSize: "15px" }} > </i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")} style={{ paddingTop: "7px", fontSize: "15px" }}></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span><i className=""></i> </span>
        );
    }
    return <div>{btnShow}</div>;
  };

  //เปลี่ยนสถานะ checkbox
  Update_Status = (Row, Status) => {
    //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
    if (Status === "0") {
      this.setState({ casschkbox: "far fa-square" });
      this.setState({ casschkboxs: false });
    }
    //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
    var dataArray = this.state.products;
    dataArray[Row].SB = Status;
    this.setState({ rows: dataArray });
    //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
    var sb_length = 0;
    console.log(this.state.products.length);
    for (var i = 0; i < this.state.products.length && this.state.products[i].Col1; i++) {
      if (this.state.products[i].SB === 1) {
        sb_length = sb_length + 1;
      }
    }
    if (sb_length === this.state.products.length) {
      this.setState({ casschkbox: "far fa-check-square" });
      this.setState({ casschkboxs: true });
    }
  };
  Search_Items = (data) => {
    this.setState({ data: data })
    this.setState({ SaleOderSub: !this.state.SaleOderSub });
  };
  onSubmit1 = () => {
    switch (this.state.key) {
      case "SelectTab1":
        var data = ""
        if (this.SalecodeMTequal.current.value !== "") {
          data += "AND a.salecode>='" + this.SalecodeMTequal.current.value + "' "
        }
        if (this.SalecodeLTequal.current.value !== "") {
          data += "AND a.salecode<='" + this.SalecodeLTequal.current.value + "' "
        }
        if (this.SalecodeMthan.current.value !== "") {
          data += "AND a.salecode>'" + this.SalecodeMthan.current.value + "' "
        }
        if (this.SalecodeLthan.current.value !== "") {
          data += "AND a.salecode<'" + this.SalecodeLthan.current.value + "' "
        }
        if (this.UserCode.current.value !== "") {
          data += "AND a.salecode='" + this.UserCode.current.value + "' "
        }
        let subdata = data.substring(4)
        if (data !== "") {
          this.props.Get_PopUpSel(subdata);
        }
        break;
      case "SelectTab2":
        var docno = "";
        let col = this.state.products
        for (var i = 0; i < col.length; i++) {
          if (col[i].SB === "1") {
            console.log(col[i].SB);
            docno += "'" + col[i].ArCode + "',"
          }
        }
        let sub = docno.substring(0, docno.length - 1);
        let sum = "a.salecode IN (" + sub + ")";
        if (docno !== "") {
          this.props.Get_PopUpSel(sum);
        }
        break;
      case "SelectTab3":
        var colSelectTab3 = this.state.products1;
        var table = "";
        for (let i = 0; i < colSelectTab3.length; i++) {
          if (colSelectTab3[i].StName !== undefined && colSelectTab3[i].SpName !== undefined) {
            table += " OR a.salecode BETWEEN '" + colSelectTab3[i].StName + "' and '" + colSelectTab3[i].SpName + "'";
          }
        }
        if (table !== "") {
          let subtb = table.substring(4);
          let sumtb = "(" + subtb + ")";
          this.props.Get_PopUpSel(sumtb);
        } else {
          this.props.Get_PopUpSel(table);
        }
        break;

      default:
        break;
    }
  };
  PopUpSelSaleRef3Sub = (type) => {
    this.setState({ PopUpTYpe5: type });
    this.setState({ SaleOderSub: !this.state.SaleOderSub });
  }

  onChange = (e) => {
    if (this.UserCode.current.value === "") {
      this.UserCode_code.current.value = ""
    }
    if (this.SalecodeMTequal.current.value === "") {
      this.SalecodeMTequal_code.current.value = ""
    }
    if (this.SalecodeLTequal.current.value === "") {
      this.SalecodeLTequal_code.current.value = ""
    }
    if (this.SalecodeMthan.current.value === "") {
      this.SalecodeMthan_code.current.value = ""
    }
    if (this.SalecodeLthan.current.value === "") {
      this.SalecodeLthan_code.current.value = ""
    }
  }
  data = (name, data) => {
    if (this.props.type === "SaleMan") {
      var Url = "CSUSER/Chkuser?code=" + data;
    }
    if (this.props.type === "Groupdata") {
      var Url = "CSDOCGROUP/Code?tablename=cssaleorder&code=" + data;
    }
    GetCorServicei(Url).then(res => {
      console.log(name);
      if (res.data.length > 0) {
        console.log(res.data[0].MYNAMETH);
        let code = res.data[0].MYNAMETH;
        if (name === "UserCode") {
          this.UserCode_code.current.value = code;
        }
        if (name === "SalecodeMTequal") {
          this.SalecodeMTequal_code.current.value = code;
        }
        if (name === "SalecodeLTequal") {
          this.SalecodeLTequal_code.current.value = code;
        }
        if (name === "SalecodeMthan") {
          this.SalecodeMthan_code.current.value = code;
        }
        if (name === "SalecodeLthan") {
          this.SalecodeLthan_code.current.value = code;
        }
      } else {
        if (name === "UserCode") {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          this.UserCode.current.value = "";
          this.UserCode_code.current.value = "";
        }
        if (name === "SalecodeMTequal") {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          this.SalecodeMTequal.current.value = "";
          this.SalecodeMTequal_code.current.value = "";
        }
        if (name === "SalecodeLTequal") {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          this.SalecodeLTequal.current.value = "";
          this.SalecodeLTequal_code.current.value = "";
        }
        if (name === "SalecodeMthan") {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          this.SalecodeMthan.current.value = "";
          this.SalecodeMthan_code.current.value = "";
        }
        if (name === "SalecodeLthan") {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          this.SalecodeLthan.current.value = "";
          this.SalecodeLthan_code.current.value = "";
        }
      }
    })
  }
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      this.data(e.target.name, e.target.value);
    }
  }
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.StCode })
    this.setState({ id: id })
    var Pr = this.state.products1;
    var j = "";
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });

    for (var i = this.state.products1.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products1 Table
      if (!Pr[i].StCode) { j = i; }
    }
    for (var i = 0; i < Pr.length; i++) {
      Pr[i].BTN_StCode = 0;
      Pr[i].BTN_SpCode = 0;
    }
    if ((col === 1 && j === id) || (col === 1 && Pr[id].StCode !== undefined && Pr[id].StCode !== "")) {
      this.setState({ col1: true });
      Pr[id].BTN_StCode = 1;
    } else if (col === 3 && typeof row.StCode !== "undefined" && row.StCode !== "") {
      Pr[id].BTN_SpCode = 1;
    }
    if (col === 1 && Pr[id].StCode !== "") {
      this.setState({ StCode: Pr[id].StCode });
      Pr[id].StCode = Pr[id].StName;
    }
    if (col === 3 && Pr[id].SpCode !== "") {
      this.setState({ SpCode: Pr[id].SpCode });
      Pr[id].SpCode = Pr[id].SpName;
    }
    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.StCode !== "undefined" && row.StCode !== "") {
      this.setState({ col: true });
    }
    this.setState({ products1: Pr });
  }
  onAfterSaveCell = (row, cellName, cellValue) => {
    console.log(cellValue, row.StName);
    if (cellName === "StCode" && cellValue !== "" && cellValue !== row.StName) {
      var url = "CSUSER/Chkuser?code=" + cellValue;
      GetCorServicei(url).then((res) => {
        if (res.data.length > 0) {
          row.StCode = res.data[0].MYNAMETH;
          row.StName = res.data[0].CODE;
        } else {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          row.StCode = "";
          row.StName = "";
        }
      })
    }
    if (cellName === "SpCode" && cellValue !== "" && cellValue !== row.SpName) {
      var url = "CSUSER/Chkuser?code=" + cellValue;
      GetCorServicei(url).then((res) => {
        if (res.data.length > 0) {
          row.SpCode = res.data[0].MYNAMETH;
          row.SpName = res.data[0].CODE;
        } else {
          AlertPopup("Warning", "ไม่พบข้อมูล!");
          row.SpCode = "";
          row.SpName = "";
        }
      })
    }
    if (cellName === "StCode" && row.StName !== "" && this.state.StCode !== "") {
      row.StCode = this.state.StCode;
    }
    if (cellName === "SpCode" && row.SpName !== "" && this.state.SpCode !== "") {
      row.SpCode = this.state.SpCode;
    }
    setTimeout(() => {
      this.reload()
    }, 500);

  }
  reload = () => {
    let pr = this.state.products1
    this.setState({ products1: pr })
  }
  S_StCode(cell, row, enumObject, rowIndex) {
    var BTN = this.state.products1[rowIndex].BTN_StCode;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Search_Items.bind(null, "table")}
            onMouseDown={(e) => { this.setState({ TBLastClick: row.C0 }); }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  S_SpCode(cell, row, enumObject, rowIndex) {
    var BTN = this.state.products1[rowIndex].BTN_SpCode;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Search_Items.bind(null, "table1")}
            onMouseDown={(e) => { this.setState({ TBLastClick: row.C0 }); }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }

  render() {
    return (
      <div className="popup" onChange={this.onChange} >
        <Backdrop open={this.state.openBackdrop} />
        {this.state.SaleOderSub ? (<PopUpSaleOder closePopup={this.PopUpSelSaleRef3Sub} table={this.props.type} Get_PopUpSelSaleRef3Sub={this.Get_PopUpSelSaleRef3Sub} type={this.state.PopUpTYpe5} Data={this.state.valuePopup5} ARCODE={this.props.ARCODE} P_DOCNO={this.P_DOCNO.current.value} from="PopUpSelSaleRef3" />) : null}
        <style jsx="true">{`
            .input-group.col-xs-12.col-sm-12.col-lg-12.col-md-12 {
                margin-bottom: 5px;
            }
            div#uncontrolled-tab-example-pane-SelectTab2 {
              margin-top: 5px;
            }
            .input-group-addon {
              width: 121px;
          }
        `}</style>
        <div className="popup_inner" >
          {this.props.Data}
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> เลือกรายการ </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="center" style={{ height: '90%' }}>
            <input type="hidden" className="form-control " ref={this.P_DOCNO} />
            <Tabs defaultActiveKey="SelectTab1" id="uncontrolled-tab-example" onSelect={(eventKey) => this.setState({ key: eventKey })}>
              <Tab eventKey="SelectTab1" title="บางรหัส" >
                <br />
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon">เท่ากับ </span>
                  <input type="text" className="form-control" name="UserCode" ref={this.UserCode}
                    tabIndex={1} onClick={this.ClickAll}
                    onKeyDown={this.onKeyDown} style={{ width: "30%" }} />
                  <input type="text" className="form-control" ref={this.UserCode_code} style={{ width: "70%" }} disabled />
                  <span id="iconGroupdata" className="input-group-addon icon" name="input1" onClick={this.Search_Items.bind(null, "1")} >{<i className="fas fa-search"></i>}</span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon">มากกว่าหรือเท่ากับ  </span>
                  <input type="text" className="form-control" name="SalecodeMTequal" ref={this.SalecodeMTequal}
                    tabIndex={1} onClick={this.ClickAll}
                    onKeyDown={this.onKeyDown} style={{ width: "30%" }} />
                  <input type="text" className="form-control " ref={this.SalecodeMTequal_code} style={{ width: "70%" }} disabled />
                  <span id="iconGroupdata" className="input-group-addon icon" name="input2" onClick={this.Search_Items.bind(null, "2")} onKeyPress={this.onKeyDown}>{<i className="fas fa-search"></i>}</span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon">น้อยกว่าหรือเท่ากับ  </span>
                  <input type="text" className="form-control" name="SalecodeLTequal" ref={this.SalecodeLTequal}
                    tabIndex={1} onClick={this.ClickAll}
                    onKeyDown={this.onKeyDown} style={{ width: "30%" }} />
                  <input type="text" className="form-control " ref={this.SalecodeLTequal_code} style={{ width: "70%" }} disabled />
                  <span id="iconGroupdata" className="input-group-addon icon" name="input3" onClick={this.Search_Items.bind(null, "3")} onKeyDown={this.onKeyDown}>{<i className="fas fa-search"></i>}</span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon">มากกว่า  </span>
                  <input type="text" className="form-control" name="SalecodeMthan" ref={this.SalecodeMthan}
                    tabIndex={1} onClick={this.ClickAll}
                    onKeyDown={this.onKeyDown} style={{ width: "30%" }} />
                  <input type="text" className="form-control " ref={this.SalecodeMthan_code} style={{ width: "70%" }} disabled />
                  <span id="iconGroupdata" className="input-group-addon icon" name="input4" onClick={this.Search_Items.bind(null, "4")} onKeyDown={this.onKeyDown}>{<i className="fas fa-search"></i>}</span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon">น้อยกว่า  </span>
                  <input type="text" className="form-control" name="SalecodeLthan" ref={this.SalecodeLthan}
                    tabIndex={1} onClick={this.ClickAll}
                    onKeyDown={this.onKeyDown} style={{ width: "30%" }} />
                  <input type="text" className="form-control " ref={this.SalecodeLthan_code} style={{ width: "70%" }} disabled />
                  <span id="iconGroupdata" className="input-group-addon icon" name="input5" onClick={this.Search_Items.bind(null, "5")} onKeyDown={this.onKeyDown}>{<i className="fas fa-search"></i>}</span>
                </div>
              </Tab>
              <Tab eventKey="SelectTab2" title="เลือกรายการ" >
                <BootstrapTable height="690" data={this.state.products} search style={{ marginTop: "50px" }}>
                  <TableHeaderColumn dataField='id' width="50" dataAlign="center" isKey>
                    <i className="fas fa-sync-alt" style={{ paddingTop: "7px", fontSize: "15px" }} onClick={() => { this.componentDidMount() }}></i> </TableHeaderColumn>
                  <TableHeaderColumn dataField='select' width="50" dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div style={{ textAlign: "center" }}>S</div> </TableHeaderColumn>
                  <TableHeaderColumn dataField='ArCode'><div style={{ textAlign: "center" }}>รหัส</div></TableHeaderColumn>
                  <TableHeaderColumn dataField='Description'><div style={{ textAlign: "center" }}>ชื่อ/คำอธิบาย</div></TableHeaderColumn>
                </BootstrapTable>
              </Tab>
              <Tab eventKey="SelectTab3" title="เลือกเป็นช่วง" >
                <br />
                <BootstrapTable height="700" data={this.state.products1}
                  options={{ noDataText: "...", onRowClick: this.onRowClick }}
                  cellEdit={{
                    mode: 'click', blurToSave: true,
                    afterSaveCell: this.onAfterSaveCell
                  }}>
                  <TableHeaderColumn row="0" rowSpan="2" dataField='N' isKey width="10" dataAlign="center"> <div style={{ textAlign: "center" }}></div> </TableHeaderColumn>
                  <TableHeaderColumn row="0" colSpan="2" dataField='Code' editable={false} width="110"><div style={{ textAlign: "center" }}>เลือกจากรหัส</div></TableHeaderColumn>
                  <TableHeaderColumn row="1" dataField="StCode" editable={this.state.col1} dataAlign="left" width="70"></TableHeaderColumn>
                  <TableHeaderColumn row="1" dataField="BTN_StCode" editable={false} dataAlign="center" width="30" dataFormat={this.S_StCode.bind(this)}></TableHeaderColumn>
                  <TableHeaderColumn row="0" colSpan="2" dataField='price1' editable={false} width="170"><div style={{ textAlign: "center" }}>เลือกถึงรหัส</div></TableHeaderColumn>
                  <TableHeaderColumn row="1" dataField="SpCode" editable={this.state.col} dataAlign="left" width="140"></TableHeaderColumn>
                  <TableHeaderColumn row="1" dataField="BTN_SpCode" editable={false} dataAlign="center" width="30" dataFormat={this.S_SpCode.bind(this)}></TableHeaderColumn>
                  <TableHeaderColumn row="0" dataField="StName" hidden ></TableHeaderColumn>
                  <TableHeaderColumn row="0" dataField="SpName" hidden ></TableHeaderColumn>
                </BootstrapTable>
              </Tab>
            </Tabs>
          </div>
          <div align="right" style={{ marginTop: '10px' }}>
            <button className="PUSDbtn" onClick={this.onSubmit1}>
              <i className="fas fa-check"> ตกลง </i>
            </button>
          </div>
        </div>
      </div >
    );
  }
}
